<template>
  <div class="flex flex_col warnpage">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item
            label="选择区域"
            style="margin-right: 10px"
            v-if="isShowAllSelect"
          >
            <el-select
              v-model="allOrgId"
              :placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
              @change="changeAllOrg"
            >
              <el-option
                v-for="(item, index) in orgAllSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="isShowAllSelect ? '' : '选择区域'"
            :class="{ 'form-item-had': isShowAllSelect }"
          >
            <el-select
              placeholder="请选择区域"
              v-model="queryParam.orgId"
              @change="changeOrg"
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备选择">
            <el-select
              :placeholder="deviceSelect.length ? '请选择设备' : '暂无设备'"
              v-model="queryParam.deviceId"
              clearable
            >
              <el-option
                v-for="(item, index) in deviceSelect"
                :key="index"
                :value="item.id"
                :label="item.deviceName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间区间" class="form-picker">
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div picker-div2"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                :clearable="true"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div picker-div2"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                :clearable="true"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的表格 -->
    <div class="warn-tables" v-loading="loading">
      <el-table
        :data="tableData"
        class="tables"
        :height="535"
        :stripe="true"
        align="center"
        header-cell-class-name="header-cell"
        cell-class-name="table-cell"
      >
        <el-table-column type="index" label="序号" width="180" align="center">
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="区域名称"
          width="180"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="设备名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="content"
          label="报警内容"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendTime"
          label="报警时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- 占位数据 -->
        <div slot="empty" class="table-empty">
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无数据</div>
        </div>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page.sync="ipagination.currentPage"
        :page-size="ipagination.pageSize"
        :total="ipagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * @description 告警信息
 */
import tableMinin from "@/mixins/TableMinin";
export default {
  mixins: [tableMinin],
  data() {
    const self = this;
    return {
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid
      disableMixinCreated: true,
      isMakeTime: false,
      isTranPage: true,
      isFillTime: true,
      ifUseLoadBack: false,
      orgSelect: [
        {
          orgName: "全部",
          orgId: "",
        },
      ], // 区域下拉选
      deviceSelect: [], // 设备选择下拉选
      tableData: [], // 列表数据
      url: {
        list: self.$api.findAlarmList,
      },
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            let num = new Date().getTime();
            if (time.getTime() > num) {
              return true;
            }
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  mounted() {
    // this.$set(this.queryParam, 'orgId', '')
    // this.loadData()
    // 获取生产区域
    // this.getOrgids()
    // 获取设备选择
    // this.getEquipSelect()
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }
  },
  methods: {
    // 获取生产区域
    // getOrgids() {
    // 	this.$http
    // 		.getOrgids()
    // 		.then((res) => {
    // 			console.log(res)
    // 			if (res.meta.success) {
    // 				let datas = res.data || []
    // 				this.orgSelect = datas || []
    // 				// this.getEquipSelect()
    // 			} else {
    // 				this.orgSelect = []
    // 			}
    // 		})
    // 		.catch(() => {
    // 			this.orgSelect = []
    // 		})
    // },
    /**
     * @param isFen 是否是分公司账号
     * @param isRequest  是否请求列表数据
     */
    getOrgids(isFen = false, isRequest = true) {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: "",
        type: "3",
      };
      if (isFen) {
        params.parentOrgId = this.allOrgId;
      } else {
        params.parentOrgId = userInfos.orgId;
      }
      console.log(params);
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgSelect = datas || [];
            if (isFen) {
              this.orgSelect.unshift({
                orgName: "全部",
                orgId: this.allOrgId,
              });
            } else {
              this.orgSelect.unshift({
                orgName: "全部",
                orgId: userInfos.orgId,
              });
            }

            if (datas.length) {
              // this.$set(this.queryParam, "orgId", datas[0]["orgId"]);
              this.$set(this.queryParam, "orgId", this.orgSelect[0].orgId);
              // 获取传感器类型
              this.getEquipSelect();
              this.$nextTick(() => {
                // 获取数据
                if (isRequest) {
                  this.loadData();
                }
              });
            } else {
              this.orgSelect = [];
              this.$set(this.queryParam, "deviceId", "");
              this.deviceSelect = [];
              setTimeout(() => {
                this.loading = false;
              }, 200);
            }
          } else {
            this.$set(this.queryParam, "orgId", "");
            this.orgSelect = [];

            this.$set(this.queryParam, "deviceId", "");
            this.deviceSelect = [];
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }
        })
        .catch(() => {
          this.$set(this.queryParam, "orgId", "");
          this.orgSelect = [];

          this.$set(this.queryParam, "deviceId", "");
          this.deviceSelect = [];
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
    getAllOrgids() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: userInfos.orgId,
        type: "2",
      };
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          console.log(res);
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgAllSelect = datas || [];
            this.orgAllSelect.unshift({
              orgName: "全部",
              orgId: userInfos.orgId,
            });
            if (datas.length) {
              // this.allOrgId = datas[0]["orgId"];
              this.allOrgId = userInfos.orgId;
              this.getOrgids(true);
              // this.$set(this.queryParam, "orgId", "");
              // this.$set(this.queryParam, "deviceId", "");
              this.loadData();
            } else {
              this.loading = false;
            }
          } else {
            this.orgAllSelect = [];
            this.allOrgId = "";
            // 设备清空
            this.$set(this.queryParam, "orgId", "");
            this.orgSelect = [];
            this.$set(this.queryParam, "deviceId", "");
            this.deviceSelect = [];
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }
        })
        .catch(() => {
          this.orgAllSelect = [];
          this.allOrgId = "";
          this.$set(this.queryParam, "orgId", "");
          this.orgSelect = [];
          this.$set(this.queryParam, "deviceId", "");
          this.deviceSelect = [];
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
    changeAllOrg(val) {
      if (val == "") {
        this.orgSelect = [];
      }
      this.allOrgId = val;
      this.orgSelect = [];
      this.$set(this.queryParam, "orgId", "");
      this.getOrgids(true, false);
    },
    // 获取设备
    async getEquipSelect() {
      let params = {
        orgId: this.queryParam.orgId,
      };
      this.$set(this.queryParam, "deviceId", "");
      await this.$http
        .getAction(this.$api.findDeviceTypeItems, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            this.deviceSelect = datas || [];
          } else {
            this.deviceSelect = [];
          }
        })
        .catch(() => {
          this.deviceSelect = [];
        });
    },
    changeOrg() {
      this.deviceSelect = [];
      this.$set(this.queryParam, "deviceId", "");
      // if (this.queryParam.orgId == "") {
      //   console.log("选择了全部区域");
      //   this.getEquipSelect();
      //   // return;
      // } else {
      //   this.getEquipSelect();
      // }
      this.getEquipSelect();
    },
    // 查询获取列表数据
    loadData(arg) {
      if (!this.url.list || this.url.list == "") {
        this.$message("请设置url.list属性!", "error");
        return;
      }
      if (arg === 1) {
        this.ipagination.currentPage = 1;
      }
      this.loading = true;
      let params = this.getQueryParams();
      if (this.isDelEmpty) {
        if (params.deviceName == "") {
          this.$delete(params, "deviceName");
        }
      }
      if (!params.orgId || params.orgId == "") {
        if (this.isShowAllSelect) {
          let orgIndex = this.orgAllSelect.findIndex((item) => {
            return item.orgId == this.allOrgId;
          });
          if (orgIndex > -1) {
            this.$set(params, "orgId", this.orgAllSelect[orgIndex]["orgId"]);
          } else {
            this.$set(params, "orgId", "");
          }
        }
      }
      this.$http
        .postAction(this.url.list, params)
        .then((res) => {
          // 判断走公共赋值还是单独数据处理
          if (this.ifUseLoadBack) {
            if (res.meta.success) {
              let datas = res.data || {};
              if (datas) {
                // 分页数据的赋值
                if (datas.totalElements) {
                  this.ipagination.total = Number(datas.totalElements);
                  this.ipagination.pageSize = datas.size;
                } else {
                  this.ipagination.total = 0;
                  this.ipagination.pageSize = 10;
                }
                // 判断走公共赋值还是单独数据处理
                this.tableData = datas || [];
              }
            }
          } else {
            let datas = res;
            // 回到页面各自独立的数据处理
            this.loadBack(datas);
          }
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch(() => {
          this.isLine = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.warnform-inline {
  .form-inputs {
    .el-form-item {
      &:not(:last-child) {
        margin-right: 2.16vw;
      }
      &.form-item-had {
        margin-right: 2.5vw;
        .el-select {
          width: 3rem;
        }
      }
    }
    .form-item-area {
      margin-right: 10px !important;
    }
  }
}
@media screen and (max-width: 1585px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 2vw;
        }
        &.form-item-had {
          margin-right: 2vw;
        }
      }
      .el-select {
        width: 2.5rem;
      }
    }
  }
}
@media screen and (max-width: 1370px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 1.3vw;
        }
        &.form-item-had {
          margin-right: 1.3vw;
          .el-select {
            width: 2.3rem;
          }
        }
      }
    }
  }
}
.warnpage {
  height: 100%;
}
.warn-tables {
  padding-bottom: 0.15rem;
  flex: 1;
  // height: 89.5%;
  min-height: 610px;
}
</style>
